"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainConfig = exports.ethereum = exports.polygon = exports.avalanche = void 0;
var base_1 = require("@web3auth/base");
exports.avalanche = {
    mainnet: {
        chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
        chainId: 43114,
        name: 'Mainnet',
        rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
        isMainnet: true,
        currencyName: 'AVAX',
        currencySymbol: 'AVAX',
        blockExplorerUrl: 'https://subnets.avax.network/c-chain',
    },
    testnet: {
        chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
        chainId: 43113,
        name: 'Fuji (Testnet)',
        rpcUrl: 'https://api.avax-test.network/ext/bc/C/rpc',
        isMainnet: false,
        currencyName: 'AVAX',
        currencySymbol: 'AVAX',
        blockExplorerUrl: 'https://subnets-test.avax.network/c-chain',
    },
};
exports.polygon = {
    mainnet: {
        chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
        chainId: 137,
        name: 'Polygon Mainnet',
        rpcUrl: 'https://rpc-mainnet.maticvigil.com',
        isMainnet: true,
        currencyName: 'Matic',
        currencySymbol: 'MATIC',
        blockExplorerUrl: 'https://polygonscan.com',
    },
    testnet: {
        chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
        chainId: 80001,
        name: 'Mumbai',
        rpcUrl: 'https://rpc-mumbai.maticvigil.com',
        isMainnet: false,
        currencyName: 'Matic',
        currencySymbol: 'MATIC',
        blockExplorerUrl: 'https://mumbai.polygonscan.com/',
    },
};
exports.ethereum = {
    mainnet: {
        chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
        chainId: 1,
        name: 'Ethereum Mainnet',
        rpcUrl: 'https://rpc.ankr.com/eth',
        isMainnet: true,
        currencyName: 'Ethereum',
        currencySymbol: 'ETH',
        blockExplorerUrl: 'https://etherscan.io',
    },
    testnet: {
        chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
        chainId: 3,
        name: 'Ropsten Testnet',
        rpcUrl: 'https://rpc.ankr.com/eth_ropsten',
        isMainnet: false,
        currencyName: 'Ethereum',
        currencySymbol: 'ETH',
        blockExplorerUrl: 'https://ropsten.etherscan.io',
    },
};
exports.chainConfig = {
    avalanche: exports.avalanche,
    polygon: exports.polygon,
    ethereum: exports.ethereum,
};
